import { render, staticRenderFns } from "./tpl-pages.vue?vue&type=template&id=433d9426&scoped=true&"
import script from "./tpl-pages.vue?vue&type=script&lang=js&"
export * from "./tpl-pages.vue?vue&type=script&lang=js&"
import style0 from "./tpl-pages.vue?vue&type=style&index=0&id=433d9426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433d9426",
  null
  
)

export default component.exports